import { gql } from '@apollo/client';

export const GET_ANALYTICS = gql`
  query ($startDate: String, $endDate: String, $cityId: String, $serviceTypeId: String, $statusCd: Int, $declaredValueBoundary: String, $companyAreaId: String, $adminUser: Boolean) {
    analytics(startDate: $startDate, endDate: $endDate, cityId: $cityId, serviceTypeId: $serviceTypeId, statusCd: $statusCd, declaredValueBoundary: $declaredValueBoundary, companyAreaId: $companyAreaId, adminUser: $adminUser)
  }
`;